import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { formatDate } from "@shared/utils/dates/formatting";
import { useTranslation } from "@shared/utils/internationalization";
import { componentName } from "@shared/utils/bem";
import {
  voucherForTT,
  voucherNotRequired,
} from "../../utils/ticket-type-utils";
import TicketVoucherText from "../TicketVoucherText/TicketVoucherText.web";
import { PaymentVerbiageProps } from "./PaymentVerbiage.props";

const PaymentVerbiage = ({
  hasPaymentPlan = false,
  eventEndsOn = undefined,
  eventStartsOn = undefined,
  customStartsOn = undefined,
  customEndsOn = undefined,
  timezone = undefined,
  ticketVoucherData = undefined,
  isOnSale = true,
}: PaymentVerbiageProps) => {
  const { t } = useTranslation("common");
  const { type, userVouchers, basketVoucherCode } = ticketVoucherData;
  const bem = componentName("payment-verbiage");

  // Prevents an empty container from being displayed on the ticket card
  const showTicketVoucherElement = Boolean(
    ticketVoucherData &&
      ((voucherNotRequired(type, userVouchers) &&
        voucherForTT(type, userVouchers)) ||
        !voucherNotRequired(type, userVouchers) ||
        (type.voucher_purchases_only && basketVoucherCode === ""))
  );

  const isHidden =
    !hasPaymentPlan &&
    !showTicketVoucherElement &&
    isOnSale &&
    !customStartsOn &&
    !customEndsOn;

  const showStartEndText = Boolean(
    (customStartsOn || customEndsOn) && timezone
  );

  return (
    <Flex
      hidden={isHidden}
      direction="column"
      fontSize={{ base: "sm", sm: "xs" }}
      className={bem.className()}
    >
      {hasPaymentPlan && (
        <Text as="i">{t("Payment plans available at checkout")}</Text>
      )}
      {showTicketVoucherElement && <TicketVoucherText {...ticketVoucherData} />}
      {showStartEndText && (
        <Flex
          direction="column"
          mt="xs"
          className={bem.element("start-end-text")}
        >
          <Text>
            {`${t("Starts")}: ${formatDate({
              date: customStartsOn || eventStartsOn,
              timezone,
              format: "EEEE MMM d, yyyy @ h:mm a (z)",
            })}`}
          </Text>

          <Text>
            {`${t("Ends")}: ${formatDate({
              date: customEndsOn || eventEndsOn,
              timezone,
              format: "EEEE MMM d, yyyy @ h:mm a (z)",
            })}`}
          </Text>
        </Flex>
      )}
    </Flex>
  );
};

export default PaymentVerbiage;
